export const states = {
    BEFORE: -1,
    WHILE: 0,
    AFTER: 1
} as const;

export type state = typeof states[keyof typeof states];